// @flow strict

import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from './menuItem.js';
import { IndustryItem } from './industryItem.js';

import * as styles from './menuCustomers.module.less';

export const MenuCustomers = ({ data }) => {
  return (
    <div className={styles.itemsWrapper}>
      <div className={styles.customersSection}>
        <div className={styles.itemsCol}>
          {data.items.map((customersItem) => {
            return <MenuItem key={customersItem.name} data={customersItem} />;
          })}
        </div>
      </div>
      {data.industries && (
        <div className={styles.industriesSection}>
            <h3 className={styles.industriesTitle}>Industries</h3>
            <div className={styles.industriesGrid}>
                {data.industries.map((industry) => (
                    <IndustryItem key={industry.title} data={industry} />
                ))}
            </div>
        </div>
      )}
    </div>
  );
};

MenuCustomers.propTypes = {
  data: PropTypes.object,
};
